import {
  includeRule,
  excludeRule,
  hideOptionSet
}
from './rules_functions.js';

  
  
export function rules_bmet(newState, state) {
  //rules with 4 conditions:
  var newrule = includeRule(newState, state, 'bmet')
  var show = hideOptionSet(newState, state, [ ['band', ['0']]])
  newrule['show']  = show
    return newrule
}


